// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__LnwZL","title":"style_title__ob1lQ","list":"style_list__RSoal","spin":"style_spin__Scs2A"};